import { useState, useEffect } from 'react';

export function useOSDetection() {
  const [os, setOs] = useState<'Unknown' | 'Windows' | 'macOS' | 'Linux' | 'Android' | 'iOS'>('Unknown');

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    let detectedOS: typeof os = 'Unknown';

    if (/iphone|ipad|ipod/i.test(userAgent)) {
      // Check iOS before macOS since iOS user agents contain "Mac OS X"
      detectedOS = 'iOS';
    } else if (/android/i.test(userAgent)) {
      // Check Android before Linux since Android user agents contain "Linux"
      detectedOS = 'Android';
    } else if (/win/i.test(userAgent)) {
      detectedOS = 'Windows';
    } else if (/mac/i.test(userAgent)) {
      detectedOS = 'macOS';
    } else if (/linux/i.test(userAgent)) {
      detectedOS = 'Linux';
    }

    setOs(detectedOS);
  }, []);

  return os;
}
